import React, {Component, Fragment} from 'react';
import GraphDate from "../common/GraphDate";
import {setActiveDate, setActiveDateIndex, setActiveDateType, setHoverDateIndex, setStandardDate} from "../../../actions/statistics/statisticsActions";
import { connect } from "react-redux";
import moment from 'moment';
import * as InitStatus from "../../../constants/common/InitializationStatus";
import fetch from "fetch-retry";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import {defaultDataProvider, makeGraphCategoryDate} from '../common/CommonHelper';
import GraphHeader from "../common/GraphHeader";
import GraphColumn from "../common/GraphColumn";
import {graphConfig} from "./BlogTrendGraphConfig";
import {browser} from '../../../utils/BrowserHelper';
import autobind from "autobind-decorator";
import {balloon} from '../common/GraphBalloon';
import If from "../../common/control/If";
import {addPrefix} from "../../../utils/UriUtil";


@connect(state => ({
  standardDate: state.statistics.standardDate,
  totalCount: state.statistics.totalCount,
  activeDate: state.statistics.activeDate,
  activeDateType: state.statistics.activeDateType,
  minDate: state.statistics.minDate,
  hoverDateIndex: state.statistics.hoverDateIndex,
  activeDateIndex: state.statistics.activeDateIndex,
}), dispatch => ({
  handleSetStandardDate(standardDate) {
    dispatch(setStandardDate(standardDate))
  },
  // 활성화된 날짜 변경
  handleSetActiveDate(activeDate) {
    dispatch(setActiveDate(activeDate))
  },
  // 활성화된 날짜 타입 변경 (day, week, month)
  handleSetActiveDateType(activeDateType) {
    dispatch(setActiveDateType(activeDateType))
  },
  // 선택된 날짜의 Index
  handleSetActiveDateIndex(activeDateIndex) {
    dispatch(setActiveDateIndex(activeDateIndex))
  },
  // hover된 날짜의 Index
  handleSetHoverDateIndex(hoverDateIndex) {
    dispatch(setHoverDateIndex(hoverDateIndex))
  }
}))
class BlogTrend extends Component {

  constructor(props) {
    super(props);
    this.defaultFormat = "YYYY-MM-DD";
    this.gap = {day: 21, week: 15, month: 12};
    this.browser = browser();
    this.graphDateWidth = {day: "36.8px", week: "51.4px", month: "64.3px"};
    this.graphStyle = this.getLoadingAndGraphHeightByBrowser();
    this.config = Object.assign({}, graphConfig);
    this.config.graphs[3].balloonFunction = (item) => balloon(item, "pv", "방문수", this.props.minDate);

    if (this.browser.isIE || this.browser.isEdge)  this.config.marginBottom = 25;  // IE대응

    const now = moment().format("YYYY-MM-DD");
    this.state = {
      initialized: InitStatus.INIT_READY,
      dataProvider: [],
      now: now,
      mouseLeaveEvent: false
    };
  }

  componentDidMount() {
    const { now } = this.state;
    this.props.handleSetStandardDate(now);
    this.props.handleSetActiveDateType("day");
    this.getTrendData(this.props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.checkIsChangedStandardDateAndType(nextProps)) {
      this.getTrendData(nextProps);
    }

    return true;
  }

  checkIsChangedStandardDateAndType(nextProps) {
    const {standardDate, activeDateType} = this.props;
    return (nextProps.standardDate != standardDate || nextProps.activeDateType != activeDateType);
  }


  // 브라우저별 그래프 style
  getLoadingAndGraphHeightByBrowser() {
    if (this.browser.isIE || this.browser.isEdge) {
      return {
        loadingHeight: {height: '301px'},
        graphHeight: {height: '272px'}
      }
    }
    else {
      return {
        loadingHeight: {height: '294px'},
        graphHeight: {height: '246px'}
      }
    }
  }

  getTrendData(nextProps) {
    const {dispatch, standardDate, activeDateType} = nextProps;

    if (standardDate == null || activeDateType == null) {
      return;
    }

    this.setState({initialized: InitStatus.INIT_DOING}, () => {
      fetch(addPrefix(`/manage/statistics/blog/${standardDate}/${activeDateType}/trend.json`), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        retries: 3,
        retryDelay: 300,
        retryOn: [500]
      })
        .then(jsonResponseHandler(dispatch))
        .then(res => res.json())
        .then(res => this.defaultData(res))
        .then(res => {
          this.setState({
            initialized: InitStatus.INIT_SUCCESS,
            dataProvider: res.data,
            categoryDate: makeGraphCategoryDate(res.data),
            maxCount: res.data.reduce((max, item) => Math.max(max, item.pv), res.data[0].pv)
          });
        })
        .catch(e => {
          console.error(e);
          this.setState({initialized: InitStatus.INIT_FAIL});
          alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
        })
    })
  }

  // defaultDataProvider 변환
  defaultData(result) {
    const {activeDateType, standardDate} = this.props;
    const gapCount = this.gap[activeDateType];
    return defaultDataProvider(result, activeDateType, standardDate, gapCount);
  }

  @autobind
  changeMouseLeaveEvent(status) {
    this.setState({mouseLeaveEvent: status});
  }


  renderGraphLoading() {
    return <div className="date_loading">
      <div className="inner_g">
        <span className="ico_blog ico_loading">로딩중입니다.</span>
      </div>
    </div>;
  }

  render() {
    const {initialized, categoryDate, dataProvider, now, maxCount, mouseLeaveEvent} = this.state;
    const {activeDateType} = this.props;
    const renderGraphDate = categoryDate && activeDateType && now;
    const dateWidth = this.graphDateWidth[activeDateType];
    const {isDoing, isSuccess} = InitStatus.init(initialized, null);

    return (
      <Fragment>
        <div className="wrap_graph column">
          <GraphHeader/>
          <div className="graph_comm"
               onMouseLeave={() => {
                 this.changeMouseLeaveEvent(true)
               }}
               onMouseEnter={() => {
                 this.changeMouseLeaveEvent(false)
               }}
          >
            <If condition={isDoing}> {this.renderGraphLoading()}</If>
            <GraphColumn
              graphStyle={this.graphStyle.graphHeight}
              activeDateType={activeDateType}
              config={this.config}
              dataProvider={dataProvider}
              maxCount={maxCount}
              mouseLeaveEvent={mouseLeaveEvent}
              trendApiStatus={initialized}
            />
            <If condition={isSuccess && renderGraphDate}>
              <div className="wrap_date">
                <GraphDate
                  categoryDate={categoryDate}
                  gap={this.gap}
                  dateWidth={dateWidth}
                  minDate="2017-12-31"
                  maxDate={now}
                  usePagination={true}
                  useDateClick={true}
                />
              </div>
            </If>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default BlogTrend;
